import { useState } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import DeviceSelector from '../DecviceSelector'
import draftService from '../../services/draftService'
import { toast } from 'react-hot-toast'
import './QuickAddModal.css'

function QuickAddModal ({ isOpen, onClose, onDraftCreated }) {
  const { user } = useAuth()
  const [formData, setFormData] = useState({
    deviceName: '',
    problemTitle: '',
    solution: '',
    errorCode: ''
  })
  const [saving, setSaving] = useState(false)

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }))
  }

  const handleSubmit = async e => {
    e.preventDefault()

    // Validation
    if (!formData.deviceName) {
      toast.error('Bitte wählen Sie ein Gerät aus.')
      return
    }

    if (!formData.problemTitle && !formData.solution) {
      toast.error('Bitte geben Sie mindestens einen Problem-Titel oder eine Lösung ein.')
      return
    }

    setSaving(true)

    try {
      const result = await draftService.saveDraft({
        deviceName: formData.deviceName,
        category: 'troubleshooting',
        problemTitle: formData.problemTitle || '',
        errorCode: formData.errorCode || null,
        problemDescription: '',
        solution: formData.solution || '',
        components: '',
        difficulty: 'medium',
        estimatedTime: null,
        toolsRequired: '',
        images: [],
        lastSavedStep: 1,
        isQuickAdd: true
      })

      if (result.success) {
        toast.success('Entwurf gespeichert! Sie können ihn später vervollständigen.')
        // Reset form
        setFormData({
          deviceName: '',
          problemTitle: '',
          solution: '',
          errorCode: ''
        })
        // Notify parent
        if (onDraftCreated) {
          onDraftCreated(result.id)
        }
        // Close modal
        onClose()
      } else {
        toast.error('Fehler beim Speichern des Entwurfs.')
      }
    } catch (error) {
      console.error('Quick-add error:', error)
      toast.error('Fehler beim Speichern: ' + (error.message || 'Unbekannter Fehler'))
    } finally {
      setSaving(false)
    }
  }

  const handleClose = () => {
    if (!saving) {
      setFormData({
        deviceName: '',
        problemTitle: '',
        solution: '',
        errorCode: ''
      })
      onClose()
    }
  }

  if (!isOpen) return null

  return (
    <div className='quick-add-modal-overlay' onClick={handleClose}>
      <div
        className='quick-add-modal-content'
        onClick={e => e.stopPropagation()}
      >
        <div className='quick-add-modal-header'>
          <h2>Schnell hinzufügen</h2>
          <button
            className='quick-add-modal-close'
            onClick={handleClose}
            disabled={saving}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className='quick-add-modal-form'>
          <div className='form-group'>
            <label>
              Gerät <span className='required'>*</span>
            </label>
            <DeviceSelector
              value={formData.deviceName}
              onChange={value => handleChange('deviceName', value)}
              disabled={saving}
              compact={false}
              showLabel={false}
            />
          </div>

          <div className='form-group'>
            <label>Problem-Titel</label>
            <input
              type='text'
              value={formData.problemTitle}
              onChange={e => handleChange('problemTitle', e.target.value)}
              placeholder='Kurze Beschreibung des Problems'
              maxLength={100}
              disabled={saving}
            />
            <span className='char-count'>
              {formData.problemTitle.length}/100
            </span>
          </div>

          <div className='form-group'>
            <label>Fehlercode (optional)</label>
            <input
              type='text'
              value={formData.errorCode}
              onChange={e => handleChange('errorCode', e.target.value)}
              placeholder='z.B. E301'
              disabled={saving}
            />
          </div>

          <div className='form-group'>
            <label>
              Lösung <span className='required'>*</span>
            </label>
            <textarea
              value={formData.solution}
              onChange={e => handleChange('solution', e.target.value)}
              placeholder='Kurze Beschreibung der Lösung...'
              rows={6}
              disabled={saving}
              required
            />
            <div className='help-text'>
              Mindestens Problem-Titel oder Lösung muss ausgefüllt sein
            </div>
          </div>

          <div className='quick-add-modal-actions'>
            <button
              type='button'
              className='btn-secondary'
              onClick={handleClose}
              disabled={saving}
            >
              Abbrechen
            </button>
            <button
              type='submit'
              className='btn-primary'
              disabled={
                saving ||
                !formData.deviceName ||
                (!formData.problemTitle && !formData.solution)
              }
            >
              {saving ? 'Wird gespeichert...' : 'Als Entwurf speichern'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default QuickAddModal

